// @ts-nocheck
import { Trans } from '@lingui/react'
import classNames from 'classnames'
import { bool, func, number, shape, string } from 'prop-types'
import { type FunctionComponent } from 'react'

import { TENANT_CH, TENANT_FR, TENANT_IT } from 'shared/consts/tenants'
import {
  EXPERIMENT_VARIATION,
  SERP_PRE_QUERY_SUGGESTIONS,
} from 'shared/experiments/consts'
import { getExperiments } from 'shared/experiments/utils/experiments'
import { InferPropsWithDefaults } from 'shared/utils/propTypes'
import { normalizeUrl } from 'shared/utils/url'
import Image from 'views/components/atoms/Image'
import SearchSuggestionName from 'views/components/organisms/SearchBox/SearchBoxListItem/SearchSuggestionName'
import useShopAndRuntimeConfig from 'views/enhancers/useShopAndRuntimeConfig'
import { SuggestContentES_v3 as SuggestContentES } from 'views/utils/propTypes'
import { isRequired } from 'views/utils/propTypeUtils'

import { SearchSuggestion } from './../types'
import { enhanceWithTrackingData } from './helpers'
import ItemPrice from './ItemPrice'
import ItemStars from './ItemStars'

const PreQueryListItem: FunctionComponent<ComponentProps> = ({
  mobile,
  item,
  highlighted,
  last,
  position,
}) => {
  const {
    id,
    name,
    prices,
    deeplink,
    thumbnailURL,
    averageRating,
    objectID,
    queryID,
  } = item as SearchSuggestion
  const {
    publicRuntimeConfig: {
      pageProperties: { experiments = [] },
      publicConfig: { tenant, locale },
    },
  } = useShopAndRuntimeConfig()

  const [preQuerySuggestionsExperiment] = getExperiments(
    [SERP_PRE_QUERY_SUGGESTIONS],
    experiments
  )

  const classList = classNames(
    'a-link a-link--no-underline o-PreQueryListItem l-flex',
    {
      'o-PreQueryListItem--highlighted': highlighted,
      'u-border--bottom@medium': !last,
    }
  )

  const productUrl = enhanceWithTrackingData(deeplink, {
    eventName: 'click on product in pre-suggest',
    eventType: 'click',
    objectIDs: `[${objectID}]`,
    position,
    queryID,
  })
  const getPricesTranslation = () => {
    if (
      preQuerySuggestionsExperiment?.isEnabled &&
      preQuerySuggestionsExperiment?.variant === EXPERIMENT_VARIATION.V1
    ) {
      if (tenant === TENANT_IT) {
        return <span>a partie da</span>
      }
      if (
        tenant === TENANT_FR ||
        (tenant === TENANT_CH && locale === 'fr-CH')
      ) {
        return <span>à partir de</span>
      }
    }
    return <Trans id="general.label.price.from" />
  }

  return (
    <li data-product-id={id}>
      <a
        className={classList}
        href={normalizeUrl(productUrl)!}
        data-clientside-hook="SearchBoxListItemLink_PQ"
      >
        <Image
          src={thumbnailURL}
          srcWidth={128}
          srcHeight={128}
          className="o-SearchBox__image u-border-radius u-background-color--background u-margin--right l-flex__fixed"
          alt={name}
        />
        <div className="l-flex l-flex--vertical-stretch l-flex__primary u-color--blue u-font-weight--bold">
          <SearchSuggestionName name={name} concat={mobile} />
          <ItemStars rating={averageRating} />
        </div>
        <span className="u-margin--left l-flex__fixed">
          <div className="o-PreQueryListItemPrice u-no-margin u-text-align--right u-text-align--left@small-tiny u-no-wrap">
            {getPricesTranslation()} <ItemPrice prices={prices} />
          </div>
        </span>
      </a>
    </li>
  )
}

const propTypes = {
  item: shape(isRequired(SuggestContentES)).isRequired,
  position: number.isRequired,
  queryStr: string,
  handleItemClick: func,
  highlighted: bool,
  last: bool,
  mobile: bool,
}

const defaultProps = {
  mobile: null,
  queryStr: '',
  handleItemClick: null,
  highlighted: false,
  last: true,
}

type ComponentProps = InferPropsWithDefaults<
  typeof propTypes,
  typeof defaultProps
>

export default PreQueryListItem
